import { type ThemeParser } from '../../../core/theme';
import { defaultsDeep } from '../../../util/data';
import type { TwoWayTreeSeriesOption } from '../../../extension/series/dvTwoWayTree/TwoWayTreeSeries';

const DARK_THEME_BUILDER = () => ({
  backgroundColor: '#1c1c1c',
  render: {
    root: {
      item: {
        children: {
          rect: {
            style: {
              fill: '#2b2b2b'
            }
          },
          text: {
            style: {
              fill: 'rgba(255,255,255,0.84)'
            }
          },
          attachment: {
            style: {
              // @ts-ignore
              _fill: ['#07ab4b', 'rgba(255,255,255,.6)', '#FF2436']
            }
          }
        }
      }
    },
    normal: {
      item: {
        children: {
          rect: {
            style: {
              fill: '#2b2b2b'
            }
          },
          text: {
            style: {
              fill: 'rgba(255,255,255,0.84)'
            }
          },
          attachment: {
            style: {
              // @ts-ignore
              _fill: ['#07ab4b', 'rgba(255,255,255,.6)', '#FF2436']
            }
          }
        }
      },
      line: {
        children: {
          line: {
            style: {
              stroke: '#6E6E6E'
            }
          }
        }
      }
    },
    group: {
      item: {
        children: {
          labelText: {
            style: {
              fill: 'rgba(255,255,255,0.60)'
            }
          },
          labelRect: {
            style: {
              fill: '#1C1C1C',
              stroke: '#6E6E6E'
            }
          }
        }
      },
      line: {
        children: {
          line: {
            style: {
              stroke: '#6E6E6E'
            }
          }
        }
      }
    }
  }
});

export function darkThemeParse(...args: Parameters<ThemeParser>) {
  (args[0].series as unknown as TwoWayTreeSeriesOption[])
    .filter(seriesOption => seriesOption.type === 'dvTwoWayTree')
    .slice()
    .forEach(seriesOption => {
      const darkTheme = DARK_THEME_BUILDER();

      // eslint-disable-next-line no-param-reassign
      seriesOption.backgroundColor = seriesOption.backgroundColor || darkTheme.backgroundColor;
      // eslint-disable-next-line no-param-reassign
      seriesOption.render = defaultsDeep(darkTheme.render, seriesOption.render || {}, {
        overlay: true,
        depth: Infinity
      });
    });

  //
}
